import React from 'react';
import './_card_label.scss';
import SvgInline from '@latitude/svg-inline';

const CardLabel = ({ text, theme, icon }) => {
  return (
    <div className={`card-label card-label--${theme.toLowerCase()}`}>
      {icon && <SvgInline className="card-label__icon" name="tick" />}
      <span className="card-label__text">{text}</span>
    </div>
  );
};

export default CardLabel;
